import React, { useState, useContext } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import axios from 'axios';
// import IconsSubmit from '../components/styled/IconsSubmit';
import NewCustomInputText from '../components/common/NewCustomInput';

const API_URL_AUTH = 'https://auth.ebslab.in/api';

const Login = () => {
  const { showToast } = useContext(GlobalContext);
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleEmailChange = (event) => {
    setEmailAddress(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const validateForm = () => {
    const errors = {};
    if (!password.trim()) {
      errors.password = 'Password is required';
    } else {
      const passwordRegex = /^.{8,}$/;
      if (!passwordRegex.test(password)) {
        errors.password =
          'Password must contain at least 8 characters with one uppercase letter, one lowercase letter, one digit, and one of the following special characters: @#$%.';
      }
    }

    if (!emailAddress.trim()) {
      errors.emailAddress = 'Email is required';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailAddress)) {
        errors.emailAddress = 'Enter a valid email address.';
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      showToast('pending', 'Processing, Please Wait...', 'top', 10);
      try {
        const response = await axios.post(`${API_URL_AUTH}/userAuthLogin`, {
          username: emailAddress,
          password: password,
        });

        const { access_token } = response.data;
        if (access_token) {
          localStorage.setItem('access_token', access_token);
          showToast('success', 'Login successful!', 'top', 10);
          const expirationTime = new Date().getTime() + 10 * 60 * 1000;
          localStorage.setItem('expirationTime', expirationTime.toString());
          window.location.replace('/');
        } else {
          showToast('error', response.data.message || 'Authentication failed.', 'top', 10);
        }
      } catch (error) {
        const errorCode = error.response?.data?.detail || 'Login failed. Please try again.'
        showToast(
          'failure',
          `Error: ${error.message}${errorCode ? ' (Code: ' + errorCode + ')' : ''}`,
          'top',
          10
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="card p-4 equal-shadow rounded-full w-100" style={{ maxWidth: '28rem' }}>
        <h1 className="mb-2 text-center text-dark fw-semibold">Login</h1>
        <form onSubmit={handleLogin}>
          <NewCustomInputText
            label="Email ID"
            name="emailAddress"
            type="email"
            value={emailAddress}
            onChange={handleEmailChange}
            placeholder="Enter email"
            required
            error={formErrors.emailAddress}
          />
          <NewCustomInputText
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Enter password"
            required
            error={formErrors.password}
          />
          {/* <div className="d-flex justify-content-end mb-3">
            <Link
              className="text-primary text-decoration-underline-hover"
              to="#"
            >
              Forgot Password?
            </Link>
          </div> */}
          <div className="d-grid mb-4 mt-4">
            <button
              className="btn btn-primary fs-4 py-2"
              type="submit"
              disabled={isLoading}
              aria-label="Login"
            >
              {isLoading ? "Login..." : 'Login'}
            </button>
          </div>
        
        </form>
      </div>
    </div>
  );
};

export default Login;